


































































































































































































































































































































































































































































































































import { BusinessUnit, CvValue, EditorialProject, Template as TemplateObj } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  CV_VALUE_COUNTRY,
  CV_VALUE_EDITORIAL_PROJECT,
  CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT,
  CV_VALUE_EDITORIAL_PROJECT_STATUS,
  CV_VALUE_MATERIAL_TYPE,
  CV_VALUE_PRODUCTION_MODE
} from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { ActionTypes } from '@/store/action-types'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { Utils } from '@/utils'

@Component
export default class UpsertEditorialProjectModal extends Vue {
  @Prop({ required: false }) editorialProject: EditorialProject

  @Watch('editorialProject', { deep: true })
  onEditorialProjectChanged() {
    this.updateEditorialProject()
  }

  private utils = Utils

  private editorialProjectSave: EditorialProject = {
    id: '',
    name: '',
    image: '',
    enabled: false,
    templateResUd: 0,
    templateResGen: 0,
    localCode: '',
    commercialEditorialProject: '',
    country: '',
    businessUnit: '',
    businessUnitId: '',
    organizationalLevel1: '',
    organizationalLevel2: '',
    materialTypes: '',
    startDate: '',
    endDate: '',
    fileNameRuleCountryDigital: false,
    fileNameRuleCountryBook: false,
    productionMode: '',
    useAnalytics: false,
    fileRootFolder: '',
    yearStart: new Date().getFullYear(),
    sharepointFolderUrl: '',
    workedBrands: '',
    subFolderPrint: '',
    status: '',
    fileRootPhysicalFolder: '',
    btovenCodeSection: '',
    btovenCodeCategory: '',
    btovenCodeSubcategory: '',
    videoWithSubtitles: false
  }

  private regexSeparator = /^([A-Za-z0-9_-]+)(,[A-Za-z0-9_-]+)*$/
  private regexSeparatorFolder = /^([A-Za-z0-9]+\|[A-Za-z0-9]+)(,[A-Za-z0-9]+\|[A-Za-z0-9]+)*$/

  private years: Array<number> = Utils.getYearsForCampaign(2019)
  private countries: CvValue[] = []
  private businessUnits: CvValue[] = []
  private businessUnitsTable: BusinessUnit[] = []
  private productionModes: CvValue[] = []
  private statuses: CvValue[] = []
  private editorialProjectsCv: CvValue[] = []
  private materialTypes: CvValue[] = []
  private templates: TemplateObj[] = []

  // The project stores the material types as a comma-separated list of code ids
  get materialTypesArray(): string[] {
    const value = this.editorialProjectSave.materialTypes
    return value ? value.split(',') : []
  }

  set materialTypesArray(codeIds: string[]) {
    Vue.set(this.editorialProjectSave, 'materialTypes', codeIds.join(','))
  }

  // The end date can't be before the start date ('YYYY-MM-DD' strings compare as dates)
  get periodState(): boolean {
    const { startDate, endDate } = this.editorialProjectSave
    return !startDate || !endDate || endDate >= startDate
  }

  get organizationalLevel1State(): boolean {
    return (this.editorialProjectSave.organizationalLevel1 == null || this.editorialProjectSave.organizationalLevel1 === '') || this.regexSeparator.test(this.editorialProjectSave.organizationalLevel1)
  }

  get organizationalLevel2State(): boolean {
    return (this.editorialProjectSave.organizationalLevel2 == null || this.editorialProjectSave.organizationalLevel2 === '') || this.regexSeparator.test(this.editorialProjectSave.organizationalLevel2)
  }

  get workedBrandsState(): boolean {
    return (this.editorialProjectSave.workedBrands == null || this.editorialProjectSave.workedBrands === '') || this.regexSeparator.test(this.editorialProjectSave.workedBrands)
  }

  get subFolderPrintState(): boolean {
    return (this.editorialProjectSave.subFolderPrint == null || this.editorialProjectSave.subFolderPrint === '') || this.regexSeparatorFolder.test(this.editorialProjectSave.subFolderPrint)
  }

  get countriesSelect() {
    return [
      { codeId: '', name: this.$i18n.t('upsert_editorial_project_modal_component.country_placeholder') as string },
      ...this.countries
    ]
  }

  get businessUnitsSelect() {
    return [
      { codeId: '', name: this.$i18n.t('upsert_editorial_project_modal_component.business_unit_placeholder') as string },
      ...this.businessUnits
    ]
  }

  get businessUnitsTableSelect() {
    return this.businessUnitsTable
  }

  get productionModesSelect() {
    return [
      { codeId: '', name: this.$i18n.t('upsert_editorial_project_modal_component.production_mode_placeholder') as string },
      ...this.productionModes
    ]
  }

  get statusesSelect() {
    return [
      { codeId: '', name: this.$i18n.t('upsert_editorial_project_modal_component.status_placeholder') as string },
      ...this.statuses
    ]
  }

  get newEditorialProject() {
    return this.editorialProject == null || !this.editorialProject.id
  }

  // A new project can't reuse the code of an existing one (the backend rejects it too)
  get idDuplicated(): boolean {
    const id = (this.editorialProjectSave.id || '').trim()
    return this.newEditorialProject && !!id &&
      this.$store.getters.editorialProjects.some((project: EditorialProject) => project.id === id)
  }

  created() {
    this.loadCountries()
    this.loadBusinnessUnits()
    this.loadBusinessUnitsTable()
    this.loadProductionModes()
    this.loadStatuses()
    this.loadTemplates()
    this.loadEditorialProjectsCv()
    this.loadMaterialTypes()
  }

  private formOk(): boolean {
    return !!this.editorialProjectSave.name && !!this.editorialProjectSave.id && this.organizationalLevel1State &&
    this.organizationalLevel2State && this.workedBrandsState && this.subFolderPrintState && this.periodState &&
    !this.idDuplicated
  }

  private async loadTemplates() {
    const response = await ApiClient.getTemplates()
    this.templates = response
  }

  private updateEditorialProject() {
    if (this.editorialProject.id !== '') {
      Vue.set(this.editorialProjectSave, 'id', this.editorialProject.id)
      Vue.set(this.editorialProjectSave, 'name', this.editorialProject.name)
      Vue.set(this.editorialProjectSave, 'image', this.editorialProject.image)
      Vue.set(this.editorialProjectSave, 'enabled', this.editorialProject.enabled)
      Vue.set(this.editorialProjectSave, 'templateResUd', this.editorialProject.templateResUd)
      Vue.set(this.editorialProjectSave, 'templateResGen', this.editorialProject.templateResGen)
      Vue.set(this.editorialProjectSave, 'localCode', this.editorialProject.localCode)
      Vue.set(this.editorialProjectSave, 'commercialEditorialProject', this.editorialProject.commercialEditorialProject)
      Vue.set(this.editorialProjectSave, 'country', this.editorialProject.country)
      Vue.set(this.editorialProjectSave, 'businessUnit', this.editorialProject.businessUnit)
      Vue.set(this.editorialProjectSave, 'businessUnitId', this.editorialProject.businessUnitId)
      Vue.set(this.editorialProjectSave, 'organizationalLevel1', this.editorialProject.organizationalLevel1)
      Vue.set(this.editorialProjectSave, 'organizationalLevel2', this.editorialProject.organizationalLevel2)
      Vue.set(this.editorialProjectSave, 'materialTypes', this.editorialProject.materialTypes || '')
      Vue.set(this.editorialProjectSave, 'startDate', this.editorialProject.startDate || '')
      Vue.set(this.editorialProjectSave, 'endDate', this.editorialProject.endDate || '')
      Vue.set(this.editorialProjectSave, 'fileNameRuleCountryDigital', this.editorialProject.fileNameRuleCountryDigital)
      Vue.set(this.editorialProjectSave, 'fileNameRuleCountryBook', this.editorialProject.fileNameRuleCountryBook)
      Vue.set(this.editorialProjectSave, 'productionMode', this.editorialProject.productionMode)
      Vue.set(this.editorialProjectSave, 'useAnalytics', this.editorialProject.useAnalytics)
      Vue.set(this.editorialProjectSave, 'fileRootFolder', this.editorialProject.fileRootFolder)
      Vue.set(this.editorialProjectSave, 'yearStart', this.editorialProject.yearStart)
      Vue.set(this.editorialProjectSave, 'sharepointFolderUrl', this.editorialProject.sharepointFolderUrl)
      Vue.set(this.editorialProjectSave, 'workedBrands', this.editorialProject.workedBrands)
      Vue.set(this.editorialProjectSave, 'subFolderPrint', this.editorialProject.subFolderPrint)
      Vue.set(this.editorialProjectSave, 'status', this.editorialProject.status)
      Vue.set(this.editorialProjectSave, 'fileRootPhysicalFolder', this.editorialProject.fileRootPhysicalFolder)
      Vue.set(this.editorialProjectSave, 'btovenCodeSection', this.editorialProject.btovenCodeSection)
      Vue.set(this.editorialProjectSave, 'btovenCodeCategory', this.editorialProject.btovenCodeCategory)
      Vue.set(this.editorialProjectSave, 'btovenCodeSubcategory', this.editorialProject.btovenCodeSubcategory)
      Vue.set(this.editorialProjectSave, 'videoWithSubtitles', this.editorialProject.videoWithSubtitles)
    } else {
      this.clearForm()
    }
  }

  private async loadCountries() {
    this.countries = await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY)
  }

  private async loadBusinnessUnits() {
    this.businessUnits = await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT)
  }

  private async loadBusinessUnitsTable() {
    try {
      this.businessUnitsTable = await ApiClient.getBusinessUnits()
    } catch (error) {
      console.error('Error loading business units table:', error)
    }
  }

  private async loadProductionModes() {
    this.productionModes = await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCTION_MODE)
  }

  private async loadStatuses() {
    this.statuses = await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_STATUS)
  }

  private async loadEditorialProjectsCv() {
    this.editorialProjectsCv = await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT)
  }

  private async loadMaterialTypes() {
    this.materialTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_MATERIAL_TYPE)
  }

  hideModal() {
    this.$bvModal.hide('UpsertEditorialProjectModal')
  }

  private saveForm(): void {
    if (this.formOk()) {
      if (this.editorialProject.id) {
        ApiClient.updateEditorialProject(this.editorialProjectSave.id, this.editorialProjectSave)
          .then((editorialProjectSaved: EditorialProject) => {
            this.$emit('editorialProjectSaved', editorialProjectSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch(this.showError)
      } else {
        ApiClient.createEditorialProject(this.editorialProjectSave)
          .then((editorialProjectSaved: EditorialProject) => {
            this.$emit('editorialProjectSaved', editorialProjectSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch(this.showError)
      }
    } else {
      this.showError(new Error(this.$t('feedback.error_message_generic') as string))
    }
  }

  // Shows the backend message (e.g. a duplicated code) instead of the generic axios one
  private showError(error: { message: string; response?: { data?: { message?: string } } }) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message
    this.$store.dispatch(ActionTypes.SHOW_TOAST, {
      title: this.$t('feedback.error_title_generic'),
      variant: 'danger',
      message
    })
  }

  private clearForm() {
    Vue.set(this.editorialProjectSave, 'id', '')
    Vue.set(this.editorialProjectSave, 'name', '')
    Vue.set(this.editorialProjectSave, 'image', '')
    Vue.set(this.editorialProjectSave, 'enabled', false)
    Vue.set(this.editorialProjectSave, 'templateResUd', 0)
    Vue.set(this.editorialProjectSave, 'templateResGen', 0)
    Vue.set(this.editorialProjectSave, 'localCode', '')
    Vue.set(this.editorialProjectSave, 'commercialEditorialProject', '')
    Vue.set(this.editorialProjectSave, 'country', '')
    Vue.set(this.editorialProjectSave, 'businessUnit', '')
    Vue.set(this.editorialProjectSave, 'businessUnitId', '')
    Vue.set(this.editorialProjectSave, 'organizationalLevel1', '')
    Vue.set(this.editorialProjectSave, 'organizationalLevel2', '')
    Vue.set(this.editorialProjectSave, 'materialTypes', '')
    Vue.set(this.editorialProjectSave, 'startDate', '')
    Vue.set(this.editorialProjectSave, 'endDate', '')
    Vue.set(this.editorialProjectSave, 'fileNameRuleCountryDigital', false)
    Vue.set(this.editorialProjectSave, 'fileNameRuleCountryBook', false)
    Vue.set(this.editorialProjectSave, 'productionMode', '')
    Vue.set(this.editorialProjectSave, 'useAnalytics', false)
    Vue.set(this.editorialProjectSave, 'fileRootFolder', '')
    Vue.set(this.editorialProjectSave, 'yearStart', new Date().getFullYear())
    Vue.set(this.editorialProjectSave, 'sharepointFolderUrl', '')
    Vue.set(this.editorialProjectSave, 'workedBrands', '')
    Vue.set(this.editorialProjectSave, 'subFolderPrint', '')
    Vue.set(this.editorialProjectSave, 'status', '')
    Vue.set(this.editorialProjectSave, 'fileRootPhysicalFolder', '')
    Vue.set(this.editorialProjectSave, 'btovenCodeSection', '')
    Vue.set(this.editorialProjectSave, 'btovenCodeCategory', '')
    Vue.set(this.editorialProjectSave, 'btovenCodeSubcategory', '')
    Vue.set(this.editorialProjectSave, 'videoWithSubtitles', false)
  }
}
